var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialReddit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -892,
    cy: 179,
    r: 262,
    fill: "#ff4500",
    transform: "matrix(.9771 0 0 .9771 1127.57 81.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.249 1.608) scale(1.99024)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200.6,
    cy: 123.7,
    r: 29.9,
    fill: "url(#prefix___Radial1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4,
    cy: 123.7,
    r: 29.9,
    fill: "url(#prefix___Radial2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.1,
    cy: 149.3,
    rx: 85.3,
    ry: 64,
    fill: "url(#prefix___Radial3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 143.1c-.5 10.8-7.7 14.8-16.1 14.8-8.4 0-14.8-5.6-14.3-16.4.5-10.8 7.7-18 16.1-18 8.4 0 14.8 8.8 14.3 19.6zM183.6 141.5c.5 10.8-5.9 16.4-14.3 16.4s-15.6-3.9-16.1-14.8c-.5-10.8 5.9-19.6 14.3-19.6s15.6 7.1 16.1 18z",
    fill: "#842123",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3 144.1c.5 10.1 7.2 13.8 15 13.8s13.8-5.5 13.4-15.7c-.5-10.1-7.2-16.8-15-16.8s-13.9 8.5-13.4 18.7z",
    fill: "url(#prefix___Radial4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 144.1c-.5 10.1-7.2 13.8-15 13.8s-13.8-5.5-13.3-15.7c.5-10.1 7.2-16.8 15-16.8s13.8 8.5 13.3 18.7z",
    fill: "url(#prefix___Radial5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1 165.1c-10.6 0-20.7.5-30.1 1.4-1.6.2-2.6 1.8-2 3.2 5.2 12.3 17.6 21 32.1 21s26.8-8.6 32.1-21c.6-1.5-.4-3.1-2-3.2-9.4-.9-19.5-1.4-30.1-1.4z",
    fill: "#bbcfda",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1 167.5c-10.6 0-20.7.5-30 1.5-1.6.2-2.6 1.8-2 3.3 5.2 12.5 17.6 21.3 32 21.3 14.4 0 26.8-8.8 32-21.3.6-1.5-.4-3.1-2-3.3-9.4-1-19.5-1.5-30-1.5z",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1 166.2c-10.4 0-20.3.5-29.5 1.4-1.6.2-2.6 1.8-2 3.2 5.2 12.3 17.3 21 31.5 21s26.3-8.6 31.5-21c.6-1.5-.4-3.1-2-3.2-9.2-.8-19.1-1.4-29.5-1.4z",
    fill: "url(#prefix___Radial6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.8,
    cy: 55.5,
    r: 21.2,
    fill: "url(#prefix___Radial7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 88c-2.5 0-4.6-1.1-4.6-2.7 0-19 15.4-34.4 34.4-34.4 2.5 0 4.6 2.1 4.6 4.6 0 2.5-2.1 4.6-4.6 4.6-13.9 0-25.2 11.3-25.2 25.2 0 1.7-2.1 2.7-4.6 2.7z",
    fill: "url(#prefix___Radial8)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3 149.1c0 3.9-4.2 5.7-9.3 5.7-5.1 0-9.3-1.8-9.3-5.7 0-3.9 4.2-7.1 9.3-7.1 5.1 0 9.3 3.1 9.3 7.1zM177.5 149.1c0 3.9-4.2 5.7-9.3 5.7-5.1 0-9.3-1.8-9.3-5.7 0-3.9 4.2-7.1 9.3-7.1 5.1 0 9.3 3.1 9.3 7.1z",
    fill: "#ff6101",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.4,
    cy: 134.8,
    rx: 3.3,
    ry: 3.6,
    fill: "#ffc49c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.3,
    cy: 134.8,
    rx: 3.3,
    ry: 3.6,
    fill: "#ffc49c"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(59.9015 0 0 -52.2545 201.012 107.557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f9fcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#edf3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dee9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d8e4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ccd8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c8d5dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ccd6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d8dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ede3e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffebef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(59.9015 0 0 -52.2545 55.892 107.557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f9fcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#edf3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dee9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d8e4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ccd8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c8d5dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ccd6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d8dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ede3e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffebef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(180.687 0 0 -126.865 130.347 99.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f9fcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#edf3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dee9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d8e4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ccd8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c8d5dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ccd6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d8dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ede3e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffebef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-15.0964 0 0 22.1628 165.28 150.971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fc4301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f43f07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e53812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4301f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.0964 0 0 22.1628 90.19 150.971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fc4301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f43f07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e53812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4301f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(53.2322 0 0 -35.1106 128.369 194.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#172e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0e1c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#030708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(46.7274 0 0 -46.7274 175.312 34.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f9fcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#edf3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dee9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d8e4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ccd8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c8d5dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ccd6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d8dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ede3e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffebef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix___Radial8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(38.3003 0 0 -38.3003 155.84 85.046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a9299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7a9299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#172e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#172e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172e35"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialReddit);
export default __webpack_public_path__ + "static/media/SocialReddit.5dd9f9f0b53a4faedf67e006368e47bd.svg";
export { ForwardRef as ReactComponent };